import React from "react";

const Success = ({style = {}, size = "36", className = "", viewBox = "0 0 36 36"}) => (
	<svg
		width={size}
		style={style}
		height={size}
		viewBox={viewBox}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={`${className || ""}`}
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<path
			d="M31.41 10.257l-3.922-1.745-1.746-3.924-4.269.446L18 2.515l-3.475 2.519-4.267-.446L8.513 8.51 4.59 10.257l.446 4.269-2.518 3.473 2.518 3.475-.446 4.266 3.923 1.745 1.746 3.924 4.27-.445L18 33.482l3.475-2.518 4.267.445 1.745-3.922 3.924-1.747-.446-4.268 2.519-3.473-2.52-3.475.447-4.267zM14.904 24.192l-4.382-4.382 1.461-1.455 2.921 2.916 8.759-8.759 1.46 1.46-10.219 10.22z"
			fill="#60B158"
		/>
		<path
			d="M33.901 17.697l-2.403-3.315.426-4.072a.516.516 0 00-.303-.525L27.88 8.12l-1.665-3.74a.52.52 0 00-.525-.304l-4.072.425-3.315-2.403a.516.516 0 00-.606 0l-3.315 2.403-4.072-.425a.523.523 0 00-.526.303L8.12 8.119 4.379 9.786a.516.516 0 00-.303.525l.425 4.072-2.403 3.315a.516.516 0 000 .606l2.403 3.315-.425 4.072a.516.516 0 00.303.525l3.74 1.665 1.665 3.74a.522.522 0 00.526.304l4.072-.425 3.315 2.403c.18.13.425.13.606 0l3.315-2.403 4.072.425c.222.023.434-.1.525-.303l1.665-3.74 3.74-1.666a.517.517 0 00.304-.525l-.426-4.072 2.403-3.315a.516.516 0 000-.606zm-3.354 3.475a.515.515 0 00-.096.356l.407 3.896-3.58 1.593a.512.512 0 00-.262.262l-1.592 3.58-3.896-.408a.515.515 0 00-.357.096L18 32.846l-3.172-2.299a.511.511 0 00-.303-.099c-.018 0-.036 0-.051.003l-3.897.407-1.592-3.58a.516.516 0 00-.262-.261L5.14 25.424l.407-3.896a.517.517 0 00-.095-.356L3.153 18l2.3-3.172a.517.517 0 00.095-.357l-.407-3.896 3.58-1.593a.511.511 0 00.262-.261l1.592-3.58 3.897.408a.52.52 0 00.356-.096L18 3.153l3.172 2.3c.103.074.23.108.356.096l3.897-.408 1.592 3.58c.052.117.145.21.262.262l3.58 1.592-.407 3.896a.514.514 0 00.095.357L32.846 18l-2.3 3.172z"
			fill="#3F9137"
		/>
		<path
			d="M24.026 12.148a.516.516 0 00-.73 0l-8.393 8.393-2.557-2.551a.516.516 0 00-.728 0l-1.464 1.454a.517.517 0 000 .73l4.382 4.383a.516.516 0 00.73 0l10.22-10.22a.516.516 0 000-.73l-1.46-1.46zm-9.123 11.314l-3.652-3.651.73-.728 2.557 2.552a.516.516 0 00.73 0l8.393-8.393.731.731-9.49 9.49z"
			fill="#3F9137"
		/>
	</svg>
);

export default Success;
